<template>
  <settings-modal
    hide-container
    class="t-manage-restriction-modal"
  >
    <div
      slot="heading"
      class="font-weight-bold"
    >{{ modalTitle }}</div>

    <error-alert :error="error" />

    <v-autocomplete
      ref="countriesInput"
      v-model="form.countryCodes"
      :error-messages="getValidationErrorMessage('countryCodes')"
      :items="countryOptions"
      :disabled="isLoading"
      item-text="name"
      item-value="value"
      label="Restricted Countries"
      multiple
      deletable-chips
      small-chips
      clearable
      class="t-countries-field"
    />

    <template slot="actions">
      <v-btn
        class="t-save-restriction"
        color="primary"
        medium
        flat
        :disabled="!isFormFilled || isLoading"
        @click="onConfirmButtonClick"
      >save</v-btn>

      <v-btn
        class="t-close-modal"
        color="primary"
        medium
        flat
        :disabled="isLoading"
        @click="onCloseButtonClick"
      >cancel</v-btn>
    </template>
  </settings-modal>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'

  import form from '@/mixins/form'
  import flashMessages from '@/mixins/flashMessages'

  import ErrorAlert from '@/components/ui/ErrorAlert'
  import SettingsModal from '@/components/modals/SettingsModal'

  export default {
    name: 'ProfileRestrictionManageModal',
    components: {
      ErrorAlert,
      SettingsModal
    },
    mixins: [form, flashMessages],
    data () {
      return {
        isLoading: false,
        error: null,
        form: {
          countryCodes: []
        }
      }
    },
    computed: {
      ...mapGetters('countries', ['countryNames']),
      ...mapGetters('modal', ['modal']),
      accountData () {
        return this.modal.data.accountData
      },
      accountRestrictionCountries () {
        if (!this.form.accountId) return []

        const groupRestriction = this.group.items.find(item => item.walletId === this.form.accountId)

        return groupRestriction ? groupRestriction.countries : []
      },
      countryOptions () {
        return Object.entries(this.countryNames)
          .map(([countryCode, countryName]) => {
            const formattedCode = countryCode.toUpperCase()

            return {
              name: `${countryName} (${formattedCode})`,
              value: formattedCode
            }
          })
      },
      modalTitle () {
        return this.modal.data.title
      },
      requiredFields () {
        return []
      },
      restrictionType () {
        return this.modal.data.restrictionType
      },
      updateRestrictionGroup () {
        return this.modal.data.updateRestrictionGroup
      }
    },
    mounted () {
      this.form.countryCodes = this.accountData.restrictions[this.restrictionType]
    },
    methods: {
      ...mapActions('modal', ['closeModal']),
      onConfirmButtonClick () {
        this.setIsLoading(true)
        this.updateRestrictionGroup(this.restrictionType, this.parsedFormInput.countryCodes, [this.accountData.accountId])
          .then(() => this.showSuccessFlashMessage('Restrictions have been successfully updated.'))
          .catch((error) => {
            this.setIsLoading(false)
            this.setError(error)
          })
      },
      onCloseButtonClick () {
        this.closeModal()
      },
      setIsLoading (isLoading) {
        this.$set(this, 'isLoading', isLoading)
      }
    }
  }
</script>
